import React from 'react';
import { connect } from 'react-redux';

import { markAsRequired } from '../../../../../../../_actions/questionnaire.actions'

const Validation = ({ question, dispatch }) => {
  return <div className="form-group">
    <label><strong>Validation</strong></label>

    <div className="custom-control custom-switch">
      <input
        onChange={(e) => { dispatch(markAsRequired(question, e.target.checked)) }}
        id={`id_${question.linkId}_required`}
        checked={question.required || false}
        type="checkbox"
        value="reqiured"
        className="custom-control-input" />
      <label
        htmlFor={`id_${question.linkId}_required`}
        className="custom-control-label">Required</label>
    </div>
  </div>
}

export default connect()(Validation);